module.exports = __webpack_public_path__ + "static/media/sort-up.1cb29d0b.svg";